import { useLocation, useNavigate, useParams } from 'react-router';
import Login from './Login/Login';
import Signup from './Signup/Signup';
import CreateaccountForm from './Signup/CreateaccountForm';
import { Forgotpassword } from './ForgotPassword/Forgotpassword';
import { useState } from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import logo_png from './logo.png'
const { Grid, Typography } = require('@mui/material');

const CommonBg = () => {
  const { pathname } = useLocation();
  const [forgotPassword, setforgotPassword] = useState(false);
  const navigate = useNavigate();
  const logo = () => {
    return (
      <svg
        width="510"
        height="214"
        viewBox="0 0 510 214"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M331.857 21.8869L253.67 101.02H220.852L268.828 53.7915C270.182 52.4374 270.297 51.6802 269.738 51.01C269.6 50.8549 269.432 50.7299 269.243 50.643C269.054 50.556 268.85 50.509 268.642 50.5049C268.434 50.5008 268.228 50.5397 268.037 50.6191C267.845 50.6985 267.671 50.8168 267.527 50.9663L217.754 101.019C217.754 101.019 191.201 101.022 187.669 101.022L239.164 48.7182C240.817 47.0647 238.642 45.422 237.407 46.6571L184.606 101.019H136.87C136.316 99.2809 136.034 97.4678 136.033 95.6436C136.033 83.0914 149.337 72.9168 165.749 72.9168C168.067 72.9151 170.38 73.1222 172.661 73.5352C174.465 73.9002 176.238 74.4037 177.965 75.0414L219.028 33.8985L223.74 29.1868L230.097 22.8293L231.041 21.8857H261.091L260.148 22.8293L257.343 25.6338C255.589 27.388 257.65 29.155 259.193 27.6108L264.682 22.0197L295.709 21.8857L292.476 25.1187C290.975 26.6202 292.907 28.5128 294.321 27.0996L299.404 21.886L331.857 21.8869Z"
          fill="#FFC200"
        />
        <path
          d="M187.666 101.487H186.565L238.832 48.3988C239.205 48.0254 239.361 47.6395 239.272 47.3088C239.227 47.1659 239.146 47.0367 239.037 46.9341C238.928 46.8314 238.795 46.7588 238.649 46.7228C238.487 46.6788 238.315 46.68 238.153 46.7267C237.991 46.7733 237.845 46.8634 237.731 46.9872L184.798 101.484H136.529L136.427 101.161C135.859 99.3782 135.57 97.5181 135.568 95.6467C135.568 82.8612 149.105 72.459 165.745 72.459C168.091 72.4577 170.431 72.6671 172.739 73.0846C174.473 73.4316 176.177 73.9096 177.839 74.5144L218.698 33.5757L230.847 21.4277H262.201L257.666 25.9626C257.382 26.2131 257.194 26.5544 257.132 26.9282C257.121 27.0356 257.133 27.1441 257.168 27.2462C257.203 27.3483 257.261 27.4413 257.336 27.5185C257.659 27.8413 258.287 27.8644 258.864 27.2879L264.486 21.5621H264.678L296.825 21.4238L292.8 25.4484C292.246 26.0019 292.322 26.5719 292.641 26.8915C292.95 27.1994 293.487 27.2835 293.993 26.7762L299.207 21.4274H332.958L253.86 101.483H219.723L268.502 53.4654C269.962 52.005 269.612 51.5856 269.381 51.3082C269.295 51.2057 269.188 51.1225 269.067 51.0643C268.946 51.006 268.815 50.974 268.681 50.9702C268.527 50.9621 268.374 50.9866 268.231 51.0422C268.088 51.0979 267.958 51.1833 267.851 51.2929L217.942 101.482H217.751C217.751 101.482 191.199 101.487 187.666 101.487ZM238.413 45.7693C238.573 45.7694 238.733 45.7904 238.888 45.8319C239.19 45.9088 239.467 46.0635 239.691 46.2808C239.914 46.498 240.077 46.7702 240.163 47.0701C240.266 47.4536 240.315 48.2209 239.487 49.0485L188.767 100.565L217.56 100.562L267.198 50.6454C267.397 50.4462 267.635 50.2904 267.897 50.188C268.16 50.0856 268.44 50.0388 268.722 50.0504C268.984 50.0592 269.242 50.1235 269.477 50.2387C269.713 50.3539 269.922 50.5177 270.09 50.7193C271.077 51.9035 270.169 53.1037 269.151 54.1216L221.975 100.562H253.475L330.75 22.3514H299.596L294.649 27.4248C293.736 28.3378 292.621 28.1753 291.989 27.5435C291.346 26.9003 291.194 25.75 292.148 24.796L294.588 22.3555L264.874 22.4836L259.519 27.9378C258.522 28.9359 257.314 28.8018 256.684 28.1709C256.512 27.9993 256.381 27.7917 256.3 27.5631C256.218 27.3344 256.189 27.0906 256.214 26.8492C256.291 26.2582 256.574 25.7133 257.014 25.311L259.974 22.3505H231.228L219.352 34.2268L178.085 75.5749L177.811 75.4803C176.107 74.8494 174.356 74.3517 172.575 73.9919C170.322 73.5844 168.037 73.3799 165.747 73.3812C149.616 73.3812 136.492 83.3694 136.492 95.6465C136.493 97.3105 136.734 98.9658 137.209 100.561H184.409L237.074 46.3389C237.249 46.1602 237.457 46.0178 237.686 45.92C237.916 45.8222 238.163 45.771 238.413 45.7691V45.7693Z"
          fill="#0F5E91"
        />
        <path
          d="M403.861 0.694029L386.01 18.8298H371.39L289.197 101.023H256.734L357.638 0.68457L403.861 0.694029Z"
          fill="#FFC200"
        />
        <path
          d="M289.39 101.484H255.619L357.45 0.222656L404.965 0.23279L386.206 19.2908H371.583L289.39 101.484ZM257.855 100.561H289.01L371.203 18.3681H385.821L402.764 1.15454L357.832 1.14486L257.855 100.561Z"
          fill="#0F5E91"
        />
        <path
          d="M275.691 0.461914L262.459 19.2213L230.059 19.1636L177.511 71.7157C172.034 70.5286 169.727 70.2669 166.657 70.2816C148.169 70.3716 133.404 81.8528 133.404 95.65C133.405 97.4685 133.66 99.2778 134.163 101.025H59.1602L98.6862 55.9743L159.286 54.7751L213.599 0.462139L275.691 0.461914Z"
          fill="#FFC200"
        />
        <path
          d="M134.773 101.486H58.1406L98.471 55.5158L159.089 54.3166L213.405 0H276.579L262.696 19.6822L230.249 19.6244L177.658 72.2186L177.413 72.1659C171.715 70.9307 169.487 70.7281 166.659 70.7421C148.576 70.83 133.864 82.0033 133.864 95.6493C133.865 97.4248 134.114 99.1913 134.605 100.898L134.773 101.486ZM60.1763 100.563H133.558C133.149 98.9571 132.942 97.3063 132.941 95.6489C132.941 81.4967 148.064 69.9097 166.654 69.8193C169.858 69.7962 172.288 70.1175 177.361 71.2106L229.867 18.7013H230.058L262.219 18.7585L274.799 0.921979H213.787L159.479 55.23L159.295 55.2343L98.8985 56.4294L60.1763 100.563Z"
          fill="#0F5E91"
        />
        <path
          d="M67.0649 134.606H58.2694C58.4386 137.101 58.7769 138.327 59.6649 139.723C61.6523 142.894 65.9654 144.628 71.4203 144.628C75.4797 144.628 78.778 143.571 80.8077 141.541C82.4992 139.892 83.4717 137.439 83.4717 134.86C83.4717 132.45 82.6683 130.674 80.9346 129.151C79.2009 127.756 77.4672 126.995 72.7312 125.769C69.9826 125.05 68.9254 124.627 68.3757 124.162C67.9952 123.866 67.7837 123.485 67.7837 123.02C67.7837 121.878 69.0523 120.948 70.7014 120.948C71.674 120.948 72.6043 121.202 73.2386 121.836C73.8729 122.343 74.042 122.851 74.338 124.077H82.8374C82.7106 121.836 82.3723 120.567 81.3574 119.003C79.4546 116.127 75.818 114.563 70.9552 114.563C66.5997 114.563 63.3014 115.578 61.314 117.565C59.6649 119.087 58.7769 121.371 58.7769 123.739C58.7769 128.179 61.3986 130.843 67.4877 132.534L71.674 133.634C73.7037 134.141 74.5494 134.818 74.5494 135.875C74.5494 137.186 73.3654 137.947 71.378 137.947C68.5449 137.947 67.4032 137.017 67.0649 134.606ZM85.6461 115.282V143.486H109.326V136.805H94.653V132.323H106.789V125.853H94.653V121.963H108.946V115.282H85.6461ZM111.558 115.282V143.486H132.997V136.551H120.438V115.282H111.558ZM135.157 115.282V143.486H156.596V136.551H144.037V115.282H135.157ZM165.961 115.282V143.486H173.953V125.388L178.858 143.486H184.736L189.641 125.473V143.486H197.718V115.282H186.512L181.818 133.887L177.336 115.282H165.961ZM209.648 115.282H199.161L209.69 133.126V143.486H218.739V132.703L228.888 115.282H218.824L214.215 125.388L209.648 115.282Z"
          fill="#0F5E91"
        />
        <path
          d="M238.08 115.282V143.486H246.96V133.718H250.258C251.78 133.718 252.922 134.014 253.641 134.606C254.275 135.114 254.782 136.298 254.782 137.27V141.034C254.782 142.049 254.909 142.641 255.29 143.486H264.17C263.536 142.514 263.409 142.133 263.409 141.457V137.017C263.409 135.029 262.944 133.295 262.056 132.281C261.379 131.477 260.491 130.885 258.842 130.166C262.056 128.644 263.24 126.783 263.24 123.231C263.24 120.525 262.436 118.665 260.576 117.185C259.011 115.874 256.77 115.282 253.429 115.282H238.08ZM250.892 127.418H247.086V121.963H251.188C252.414 121.963 253.302 122.09 253.768 122.343C254.402 122.682 254.867 123.654 254.867 124.711C254.867 126.699 253.768 127.418 250.892 127.418ZM266.138 115.282V143.486H275.018V115.282H266.138ZM299.284 140.738L299.706 143.486H305.584V127.883H293.237V134.014H297.254C296.62 136.255 295.055 137.355 292.518 137.355C288.67 137.355 286.64 134.775 286.64 129.828C286.64 124.373 288.585 121.455 292.137 121.455C294.505 121.455 296.028 122.682 296.493 124.881H305.119C304.95 122.555 304.569 121.371 303.554 119.849C301.398 116.466 296.873 114.351 291.968 114.351C283.13 114.351 277.38 120.356 277.38 129.617C277.38 138.539 282.834 144.29 291.418 144.29C295.097 144.29 297.042 143.444 299.284 140.738Z"
          fill="#FFC200"
        />
        <line
          x1="62"
          y1="168"
          x2="343"
          y2="168"
          stroke="white"
          stroke-width="4"
          stroke-linecap="round"
        />
        <line
          x1="107"
          y1="182"
          x2="298"
          y2="182"
          stroke="white"
          stroke-width="4"
          stroke-linecap="round"
        />
      </svg>
    );
  };
  return (
    <>
      <Dialog
        open={forgotPassword}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          className="absolute right-4 top-4"
          onClick={() => {
            setforgotPassword(false);
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Forgotpassword setforgotPassword={setforgotPassword} />
        </DialogContent>
      </Dialog>

      <Grid
        container
        className="h-[100vh] bg-no-repeat !bg-cover bg-left w-full "
        sx={{
          backgroundImage:
            'radial-gradient(circle, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.88) 100%),url(/assets/auth-bg.jpg)',
        }}
      >
        <Grid item container>
          <Grid item container lg={6}>
            <Grid
              item
              container
              alignItems="center"
              justifyContent="center"
              className="m-auto px-10 py-5"
            >
              <Grid
                className="-ml-20 -mt-2 cursor-pointer text-center w-[440px] h-[214px]"
                onClick={() => {
                  navigate('/');
                }}
                item
              >
                {/* {logo()} */}
                <img className='w-full' src={logo_png} alt="" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item container className="bg-white !rounded-l-3xl p-10" lg={6}>
            {pathname === '/signup' ? (
              <Signup />
            ) : pathname == '/login' ? (
              <Login setforgotPassword={setforgotPassword} />
            ) : (
              <CreateaccountForm />
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CommonBg;
